import { useQuery } from "react-query";
import { getDuplicateStagingAttributeGroups } from "components/duplicate-staging/lib/productData";

export const useGetDuplicateStagingAttributeGroups = () => {
    return useQuery({
        queryKey: ["duplicateStageAttributeGroups"],
        queryFn: () => getDuplicateStagingAttributeGroups(),
    });
};
